import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    // hide the default launcher when initialized and when the widget is closed
    // we implement a custom launcher and call 'show' when it is clicked, see #open
    zE('webWidget', 'hide')
    zE('webWidget:on', 'close', () => {
      zE('webWidget', 'hide')
    });
  }

  open = () => {
    zE('webWidget', 'show')
    zE('webWidget', 'open')
  }
}
